/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ComponentsButtonComponent } from './ComponentsButtonComponent'
import type { UploadFile } from './UploadFile'
export type SectionsFeatureComponent = {
  id?: number
  __component?: string
  title?: string
  subTitle?: string
  content?: string
  visual?: UploadFile
  direction?: SectionsFeatureComponent.direction
  button?: Array<ComponentsButtonComponent>
  noCutout?: boolean
  style?: SectionsFeatureComponent.style
}
export namespace SectionsFeatureComponent {
  export enum direction {
    LEFT = 'Left',
    CENTER = 'Center',
    RIGHT = 'Right',
  }
  export enum style {
    PRIMARY = 'Primary',
    SECONDARY = 'Secondary',
    TERTIARY = 'Tertiary',
    WHITE = 'White',
  }
}
